import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import NavIcon from '../ui/NavIcon';
import { services } from '../../data/navigation';

const ServicesDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors flex items-center"
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => setIsOpen(true)}
      >
        Services
        <ChevronDown className="ml-1 w-4 h-4" />
      </button>

      {isOpen && (
        <div
          className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-lg py-2"
          onMouseLeave={() => setIsOpen(false)}
        >
          {services.map((service) => (
            <Link
              key={service.path}
              to={service.path}
              className="flex items-center px-4 py-3 hover:bg-gray-50 transition-colors"
              onClick={() => setIsOpen(false)}
            >
              <div 
                className="w-8 h-8 rounded-lg flex items-center justify-center mr-3"
                style={{
                  backgroundColor: `${service.color}15`,
                  color: service.color
                }}
              >
                <NavIcon name={service.iconName} />
              </div>
              <span className="text-gray-700">{service.name}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServicesDropdown;